/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import "@mdi/font/css/materialdesignicons.css"
import "@fortawesome/fontawesome-free/css/all.css"
import "vuetify/styles"

// Composables
import { createVuetify, ThemeDefinition } from "vuetify"
import { fa } from "vuetify/iconsets/fa"
import { aliases, mdi } from "vuetify/iconsets/mdi"
import { de, en } from "vuetify/locale"

const myCustomLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    "primary": "#E21836", // Live Nation Red
    "secondary": "#000000", // Black
    "accent": "#E21836", // Live Nation Red
    "error": "#E21836", // Use Live Nation Red for error states
    "info": "#E21836", // Use Live Nation Red for info
    "success": "#E21836", // Use Live Nation Red for success
    "warning": "#000000", // Black for warnings
    "background": "#FFFFFF", // White background
    "surface": "#FFFFFF", // White surface
    "on-primary": "#FFFFFF",
    "on-secondary": "#FFFFFF",
    "on-surface": "#000000",
    "on-background": "#000000",
    // Semantic colors for alerts (traditional UX colors)
    "semantic-success": "#4CAF50", // Green - positive/complete states
    "semantic-warning": "#FF9800", // Amber - attention needed
    "semantic-error": "#F44336", // Red - errors/problems
    // Budget-specific colors for refactored components
    "primary-darken-1": "#C11526", // Darker Live Nation Red for avatars
    "action-success": "#28a745", // Green for "Save All" button
    "progress-good": "#2e7d32", // Green for progress bars (normal state)
    "surface-white": "#FFFFFF" // White chip background
  }
}

const defaults = {
  VBtn: {
    rounded: 0
  },
  VCard: {
    rounded: 0
  },
  VSheet: {
    rounded: 0
  },
  VTextField: {
    rounded: 0
  },
  VSelect: {
    rounded: 0
  },
  VAutocomplete: {
    rounded: 0
  },
  VCombobox: {
    rounded: 0
  },
  VTextarea: {
    rounded: 0
  },
  VChip: {
    /*rounded: 0*/
  },
  VBadge: {
    /*rounded: 0*/
  },
  VAlert: {
    rounded: 0
  },
  VDialog: {
    rounded: 0
  },
  VMenu: {
    rounded: 0
  }
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  defaults,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      fa,
      mdi
    }
  },
  theme: {
    defaultTheme: "myCustomLightTheme",
    themes: {
      myCustomLightTheme
    },
    variations: {
      colors: [],
      lighten: 0,
      darken: 0
    }
  },
  locale: {
    locale: "de",
    messages: { de, en }
  }
})
